import React from "react";
import {Box, Container, Typography} from "@mui/material";
import PageHeader from "../components/modern/PageHeader";
import SectionTitle from "../components/modern/SectionTitle";
import RiderGrid, {STAT_LABELS} from "../components/modern/RiderGrid";
import Reveal from "../components/modern/Reveal";
import {useRiders} from "../data/sheet";
import {colors, displayFont} from "../styling/GlobalTheme";

/* Coureurs & palmarès (onglet "Coureurs" du Google Sheet) */
function HallofFame() {
    const {data: riders} = useRiders();
    const totals = STAT_LABELS.map(([k, label]) => [label, riders.reduce((s, r) => s + (Number(r[k]) || 0), 0)] as const)
        .filter(([, v]) => v > 0);

    return (
        <>
            <PageHeader title="Champions" subtitle="Les coureurs du Mouch'Paba et leur palmarès."
                        image={process.env.PUBLIC_URL + "/images/fis2024/globes.jpg"}/>
            {totals.length > 0 && (
                <Box sx={{bgcolor: colors.night, color: "#fff", pb: 6}}>
                    <Container maxWidth="lg" sx={{display: "grid", gridTemplateColumns: {xs: "1fr 1fr", md: `repeat(${totals.length}, 1fr)`}, gap: 2}}>
                        {totals.map(([label, v], i) => (
                            <Reveal key={label} delay={i * 100}>
                                <Box sx={{textAlign: "center", border: "1px solid #1f2b44", borderRadius: 4, py: 3}}>
                                    <Typography sx={{fontFamily: displayFont, fontSize: {xs: "3rem", md: "4.2rem"}, lineHeight: 1, color: colors.glacier}}>{v}</Typography>
                                    <Typography sx={{fontSize: ".8rem", textTransform: "uppercase", letterSpacing: 1, color: "#aab4c5"}}>{label}</Typography>
                                </Box>
                            </Reveal>
                        ))}
                    </Container>
                </Box>
            )}
            <Box component="section" sx={{py: {xs: 6, md: 9}}}>
                <Container maxWidth="lg">
                    <SectionTitle kicker="L'équipe" title="Nos coureurs" subtitle="Cliquez sur un coureur pour voir sa fiche."/>
                    <RiderGrid riders={riders}/>
                </Container>
            </Box>
        </>
    );
}

export default HallofFame;
